import React from 'react';

import { Paper, TextInput, Title, createStyles, Group, SegmentedControl } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { DemoGymList } from 'types/generated';

import CreateDemoGymButtonMenu from './CreateDemoGymButtonMenu';
import { SearchFilters } from './types';

const useStyles = createStyles(theme => ({
  header: {
    padding: theme.spacing.lg,
    background: theme.colors.gray[0],
    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    display: 'grid',
    gridTemplateColumns: 'auto 500px',
    gridTemplateRows: 'auto',
    gridTemplateAreas: `"title search"`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: 'auto',
      gridTemplateRows: 'auto auto',
      gridTemplateAreas: `
        'title'
        'search'
      `,
    },
  },
  title: {
    gridArea: 'title',
  },
  search: {
    gridArea: 'search',
  },
}));

const DemoGymPageHeader = ({
  searchFilters,
  setSearchFilters,
}: {
  searchFilters: SearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<SearchFilters>>;
}): JSX.Element => {
  const { classes } = useStyles();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchFilters(prev => ({ ...prev, search: value }));
  };
  const handleTypeChange = (value: DemoGymList['type']): void => {
    setSearchFilters(prev => ({ ...prev, type: value }));
  };

  return (
    <Paper className={classes.header}>
      <Title order={1} size='h1' className={classes.title}>
        Demo Gyms
      </Title>
      <Group className={classes.search} style={{ gridArea: 'search' }} position='right'>
        <TextInput
          icon={<IconSearch />}
          placeholder='Search by demo gym or prospect'
          value={searchFilters.search}
          onChange={handleSearchChange}
          miw={300}
        />

        <CreateDemoGymButtonMenu />
      </Group>

      <Group>
        <SegmentedControl
          value={searchFilters.type}
          onChange={handleTypeChange}
          data={[
            { label: 'Time-Limited', value: 'TIME_LIMITED' as DemoGymList['type'] },
            { label: 'Persistent', value: 'PERSISTENT' as DemoGymList['type'] },
          ]}
          size='md'
          miw={300}
        />
      </Group>
    </Paper>
  );
};

export default DemoGymPageHeader;
